import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Notification from '../../../components/Common/Notification';
import RadioButtonGroup from "../../../components/Form/RadioButtonGroup";

import { connect, useDispatch } from 'react-redux';
import CustomTextField from "../../../components/Form/CustomTextField";
import CustomButton from "../../../components/Form/CustomButton";
import { addPayment, getPaymentDetails, resetPaymentState, updatePayment, updatePaymentConfiguration } from "../../../store/actions";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import CustomSelect from "../../../components/Form/CustomSelect";



const AddPaymentMethod = ({ type, title, paymentDetails, updateConfiguration, updatePaymentInfo, formError, addPaymentMethod }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const defaultValues = {
        title: "",
        visibility: "",
        metaTitle: "",
        metaDesc: ""
    }

    const { ID } = useParams();
    const [values, setFormValues] = useState(defaultValues);
    const [loading, setIsLoading] = useState();

    const [error, setError] = useState();

    const data = [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
    ]

    const initData = () => {
        setIsLoading(false);
        dispatch(getPaymentDetails({ id: ID }))
    }

    useEffect(() => {
        dispatch(resetPaymentState());
        if (type === "Edit") {
            if (ID) {
                initData();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (updateConfiguration?.code === 'success') {
            dispatch(resetPaymentState());
            values?.type === "online" && setNotification({
                open: true,
                msg: "Payment method updated successfully",
                type: "success"
            })
            setIsLoading(false);
            initData()
        } else if (updateConfiguration?.code === 'error' || updateConfiguration?.code === 'failed' || updateConfiguration?.code === 'invalid_field') {
            setNotification({
                open: true,
                msg: 'Update failed.',
                type: "error"
            })
            setIsLoading(false);
            // dispatch(resetPaymentState());
        }
    }, [updateConfiguration])

    useEffect(() => {
        if (updatePaymentInfo?.code === 'success') {
            setIsLoading(false);
            values?.type === "offline" && setNotification({
                open: true,
                msg: "Payment method updated successfully",
                type: "success"
            })
            initData();
            handleUpdateConfiguration()
            values?.type === "offline" && initData();
        } else if (updatePaymentInfo?.code === 'failed' || updatePaymentInfo?.code === 'invalid_field') {
            setNotification({
                open: true,
                msg: 'Please fill in all requried field',
                type: "error"
            })
            setIsLoading(false);
            dispatch(resetPaymentState());
        }
    }, [updatePaymentInfo])

    useEffect(() => {
        if (addPaymentMethod?.code === 'success') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: "Payment method added successfully",
                type: "success"
            })
            navigate("/settings-payment-methods");
            dispatch(resetPaymentState());
            initData();
        } else if (addPaymentMethod?.code !== 'success') {
            // setNotification({
            //     open: true,
            //     msg: 'Please fill in all requried field',
            //     type: "error"
            // })
            setIsLoading(false);
        }
    }, [addPaymentMethod])


    useEffect(() => {
        if (paymentDetails?.length > 0) {
            setFormValues({
                type: paymentDetails[0]?.type,
                status: paymentDetails[0]?.status,
                method_name: paymentDetails[0]?.name,
                currency_code: paymentDetails[0]?.currency_code,
                publishable_key: paymentDetails[0]?.configurations?.find((config) => config.key === "publishable_key")?.value || "",
                secret_key: paymentDetails[0]?.configurations?.find((config) => config.key === "secret_key")?.value || "",
            })
            setIsLoading(false);
        }
    }, [paymentDetails]);

    const handleUpdateConfiguration = () => {
        let configurationPayload = {
            payment_method_id: ID,
            configurations: [
                {
                    "payment_method_id": 1,
                    key: "publishable_key",
                    value: values?.publishable_key || ""
                },
                {
                    "payment_method_id": 1,
                    key: "secret_key",
                    value: values?.secret_key || ""
                }
            ]
        }
        setIsLoading(true);
        values?.type === "online" && dispatch(updatePaymentConfiguration({ id: ID, data: configurationPayload }));
    }
    const handleSubmit = (type) => {
        if (type === "Edit") {
            let paymentPayload = {
                type: values.type,
                status: values.status,
                name: values.method_name,
                currency_code: values.currency_code,
            }
            if (values?.type === "online") {
                if (!values?.publishable_key ||  !values?.secret_key) {
                    setNotification({
                        open: true,
                        msg: "Publishable Key and Secret Key field is required for online payment method.",
                        type: "error"
                    })
                } else {
                    dispatch(updatePayment({ id: ID, data: paymentPayload }));
                    setIsLoading(true);
                }
            } else {
                dispatch(updatePayment({ id: ID, data: paymentPayload }));
                setIsLoading(true);
            }
        } else if (type === "Add") {
            let paymentPayload = {
                type: values.type,
                status: values.status,
                name: values.method_name,
                currency_code: values.currency_code,
                payment_method_id: values.type === "offline" ? 2 : 1,
                configurations: values?.type === "offline" ?
                    [] : [
                        {
                            "payment_method_id": 1,
                            key: "publishable_key",
                            value: values?.publishable_key || ""
                        },
                        {
                            "payment_method_id": 1,
                            key: "secret_key",
                            value: values?.secret_key || ""
                        }
                    ]
            }
            dispatch(addPayment(paymentPayload));
            setIsLoading(true);
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <LoadingDialog open={loading || (type === 'Edit' && !paymentDetails)} />
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={"/settings-payment-methods"}
                        breadcrumbItems={[{ title: "Payment Methods", link: "/settings-payment-methods" },
                        { title: title, link: "#" },
                        ]}
                    >
                        <CustomButton
                            title={type === 'Add' ? 'Save' : 'Save Changes'}
                            press={() => handleSubmit(type)}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />
                    </Breadcrumbs>
                    <Grid container spacing={1.5}>
                        <Grid item sm={12} lg={8}>
                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">BASIC INFO</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <CustomSelect
                                                title={'Payment type'}
                                                data={[
                                                    { label: "Online", value: "online" },
                                                    { label: "Offline", value: "offline" },
                                                ]}
                                                values={values?.type || -1}
                                                onChange={(e) => {
                                                    setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        type: e
                                                    }));
                                                }}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.type || ""}</FormHelperText>}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Payment method name'}
                                                values={values?.method_name}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    method_name: e
                                                }))}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.name || ""}</FormHelperText>}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Currency code'}
                                                values={values?.currency_code}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    currency_code: e
                                                }))}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.currency_code || ""}</FormHelperText>}
                                        </Grid>
                                    </Grid>
                                </CardBody>
                            </Card>
                            {values?.type === "online" &&
                                <Card className="p-3 px-2 mt-3">
                                    <CardBody>
                                        <div className="setting-header">GATEWAY CONFIGURATION</div>
                                        <Divider className="my-2 mb-4" />
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12}>
                                                <CustomTextField
                                                    title={"Publishable Key"}
                                                    values={values?.publishable_key}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        publishable_key: e
                                                    }))} />
                                                {error && <FormHelperText sx={{ color: "red" }}>{error?.[`configurations.0.value`] || ""}</FormHelperText>}
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <CustomTextField
                                                    title={"Secret Key"}
                                                    values={values?.secret_key}
                                                    onChange={(e) => setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        secret_key: e
                                                    }))} />
                                                {error && <FormHelperText sx={{ color: "red" }}>{error?.[`configurations.1.value`] || ""}</FormHelperText>}
                                            </Grid>
                                        </Grid>
                                    </CardBody>
                                </Card>}
                        </Grid>
                        <Grid container item sm={12} lg={4}>
                            <Grid item xs={12} sm={12}>
                                <Card className="p-3 px-2">
                                    <CardBody>
                                        <div className="setting-header">SETTINGS</div>
                                        <Divider className="my-2 mb-4" />
                                        <div className="mt-3">
                                            <RadioButtonGroup
                                                title={'Status'}
                                                value={parseInt(values?.status)}
                                                data={data}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    status: e,
                                                }))}
                                                required="true"
                                                name="status"
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                                        </div>
                                    </CardBody>
                                </Card>

                            </Grid>
                        </Grid>
                    </Grid>
                    {/* </CardBody>
                    </Card> */}
                </Container>
            </div>
        </React.Fragment >
    );
};
function mapStateToProps({ Payment }) {
    console.log("PaymentPayment", Payment)
    return {
        paymentDetails: Payment.paymentDetails?.data?.data,
        updatePaymentInfo: Payment.updatePayment,
        updateConfiguration: Payment.updatePaymentConfiguration,
        addPaymentMethod: Payment.addPayment,
        formError: Payment.error
    };
}

export default connect(mapStateToProps)(AddPaymentMethod);
